import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getQcCheck = createAsyncThunk('/qc_check/content', async (nopage) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/companyFileCheckQc?page=${nopage}`, {})
        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 401) {
            window.location.href = '/login';
        }
    }
})


export const qcCheckSlice = createSlice({
    name: 'qc_check',
    initialState: {
        isLoading: false,
        qc_check: []
    },

    extraReducers: (builder) => {
        builder
            .addCase(getQcCheck.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getQcCheck.fulfilled, (state, action) => {
                state.qc_check = action.payload.data;                  
                state.isLoading = false;
            })
            .addCase(getQcCheck.rejected, (state) => {
                state.isLoading = false;
            });
    }   
})

export default qcCheckSlice.reducer